import React, { useCallback } from 'react'
import { Attachment } from '@/checkout-instore-legacy/product/typings'

import BaseModal from './BaseModal'
import { AttachmentForm, SubmitProps } from './AttachmentForm'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'
import { AttachmentModalBaseProps } from './AttachmentModal'

interface AttachmentModalProps extends AttachmentModalBaseProps {
  attachment: Attachment
}

export const SingleAttachments = ({
  isOpen,
  attachment,
  onSubmit,
  onClose,
  ...rest
}: AttachmentModalProps) => {
  const { formatMessage } = useIntl()

  const handleSubmit = useCallback(
    (values: SubmitProps) => {
      onSubmit([values])
    },
    [onSubmit]
  )

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={formatMessage({ id: 'attachments.modal.title' })}
      {...rest}
    >
      <AttachmentForm
        attachment={attachment}
        formSubmitLabel="attachments.modal.save-and-add-to-cart"
        onSubmit={handleSubmit}
      />
    </BaseModal>
  )
}
